var map = {
	"./0.svg": "bf0a",
	"./1.svg": "4e7c",
	"./2.svg": "3ac2",
	"./3.svg": "f9f6",
	"./4.svg": "eb92",
	"./5.svg": "ec2d",
	"./6.svg": "bcb7",
	"./czpg.svg": "f436",
	"./donw.svg": "7bc5",
	"./gr.svg": "c7fa",
	"./jcxx.svg": "ef53",
	"./jxb.svg": "e19e",
	"./ls.svg": "943b",
	"./lsfb.svg": "a535",
	"./up.svg": "81ca",
	"./zc.svg": "a696",
	"./zy.svg": "c662"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "779b";